// extracted by mini-css-extract-plugin
export default {"wrapper":"Bottom_wrapper__zSw-Y","row":"Bottom_row__ws1q-"};